import { useQueryClient } from "@tanstack/react-query";
import { Button } from "Components/_Shared/Buttons/Button";
import { DialogModal } from "Components/_Shared/DialogModal";
import { AnalysisWriteForbiddenErrorCode } from "Infrastructure/ApiZfp/Schema";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useEffect, useState } from "react";

const isAnalysisWriteForbiddenCode = (code: unknown): code is AnalysisWriteForbiddenErrorCode =>
  Object.values<unknown>(AnalysisWriteForbiddenErrorCode).includes(code);

export const AnalysisWriteForbiddenModal = () => {
  const { t } = useResource();
  const queryClient = useQueryClient();
  const [errorCode, setErrorCode] = useState<AnalysisWriteForbiddenErrorCode | null>(null);

  // listening on the cache catches every mutation of the page, including those with their own onError
  useEffect(
    () =>
      queryClient.getMutationCache().subscribe((event) => {
        if (event.type !== "updated" || event.action.type !== "error") return;

        const code = event.action.error?.code;
        if (isAnalysisWriteForbiddenCode(code)) {
          setErrorCode((current) => current ?? code);
        }
      }),
    [queryClient],
  );

  const texts =
    errorCode === AnalysisWriteForbiddenErrorCode.analysis_not_editable
      ? Resources.AnalysisDetail.WriteForbidden.NotEditable
      : Resources.AnalysisDetail.WriteForbidden.ReadOnlyAccess;

  return (
    <DialogModal
      size="sm"
      isOpen={errorCode !== null}
      title={t(texts.Title)}
      subtitle={t(texts.Text)}
      primaryAction={<Button onClick={() => window.location.reload()}>{t(Resources.AnalysisDetail.WriteForbidden.Reload)}</Button>}
    />
  );
};
